import cn from "@/v2-ui/utils/utils.cn"
import type { PublicHistoryDay } from "@/v2-status-client/status/status.types"
import { describeDay } from "@/v2-status-client/status/history/status.history.utils"

export type StatusHistoryCellProps = {
  day: PublicHistoryDay
  isToday: boolean
}

// Per-status background tone for a cell. Slightly muted from the
// dot palette so a wall of green doesn't strobe; the same hue
// family keeps the metaphor consistent with StatusDot.
const CELL_TONE: Record<PublicHistoryDay["status"], string> = {
  operational: "bg-emerald-500/70 hover:bg-emerald-400",
  degraded: "bg-amber-400/80 hover:bg-amber-300",
  down: "bg-red-500/80 hover:bg-red-400",
}

// One day in the 30-day strip. Flex/min-width comes from the
// `.status-history-bar-cell` rule in `status.css` so the strip
// can fan out across phone-to-desktop without us reaching for a
// container query. The "today" cell gets an outline so customers
// can anchor "right now" -- handled in the same CSS rule because
// outline-offset can't be expressed via Tailwind without
// arbitrary values per cell.
function StatusHistoryCell(props: Readonly<StatusHistoryCellProps>) {
  const { day, isToday } = props
  return (
    <div
      className={cn(
        "status-history-bar-cell h-4 rounded-[3px] transition-colors",
        CELL_TONE[day.status],
        isToday && "status-history-bar-cell-today",
      )}
      title={`${day.date}${isToday ? " (today)" : ""}: ${describeDay(day)}`}
    />
  )
}

export default StatusHistoryCell
